import { css } from 'linaria';

export const modalMediaCardGallerySwiper = css`
  && {
    width: 100%;
    height: 100%;

    .swiper-button-prev {
      border: none;

      &:hover {
        background-color: var(--control-secondary);
      }
    }

    .swiper-button-next {
      border: none;

      &:hover {
        background-color: var(--control-secondary);
      }
    }

    @media (--to-desktop) {
      padding: 0;
      margin: 0;
    }
  }
`;

export const modalMediaCardGallerySlide = css`
  display: flex;

  @media (--from-desktop) {
    flex-wrap: wrap;
  }

  @media (--to-desktop) {
    flex-direction: column;
  }
`;
